import * as React from 'react';

import routes from 'defs/routes';
import i18n from 'helper/i18n';
import { HistoryType } from 'types/withRouter';

import Link from 'components/atoms/Link';

export type BoardTrendButtonPropsType = {
	onClick: () => void;
	history: HistoryType;
};

export const BoardTrendButton = ({ onClick, history }: BoardTrendButtonPropsType) => (
	<div className="m-board-trend__button">
		<Link
			onClick={(event: React.MouseEvent<any>) => {
				if (event && event.preventDefault) {
					event.preventDefault();
				}
				onClick();
				history.push(routes.dashboard.newMeasurement.href);
			}}
			title={i18n('react.impulsCoach.molecules.BoardTrendButton.title')}
			modifier="button"
		/>
	</div>
);

BoardTrendButton.displayName = 'BoardTrendButton';

export default BoardTrendButton;
